import PinchZoom from './PinchZoom';

export default PinchZoom;
